import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { CalendarDays, ArrowRight } from 'lucide-react';
import api from '../../services/api';

interface DrillData { title: string; columns: string[]; rows: (string | number)[][] }

const statusChip = (status: string) => {
  const s = (status || '').toLowerCase();
  if (s.includes('confirm')) return 'son-chip son-chip-green';
  if (s.includes('attente')) return 'son-chip son-chip-amber';
  if (s.includes('réalis') || s.includes('realis')) return 'son-chip son-chip-blue';
  if (s.includes('annul') || s.includes('honor')) return 'son-chip son-chip-red';
  return 'son-chip son-chip-gray';
};

const RdvDuJour: React.FC = () => {
  const navigate = useNavigate();
  const { data, isLoading } = useQuery({
    queryKey: ['dashboard', 'drilldown', 'rdv_jour'],
    queryFn: () => api.get<DrillData>('/dashboard/analytics/drilldown/', { params: { metric: 'rdv_jour' } }).then((r) => r.data),
  });

  const rows = data?.rows || [];

  return (
    <div className="son-panel p-5">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <span className="w-8 h-8 rounded-xl flex items-center justify-center" style={{ background: 'var(--teal-soft)', color: 'var(--teal)' }}>
            <CalendarDays className="h-4 w-4" />
          </span>
          <h3 className="font-extrabold text-gray-900 text-[15px]">Rendez-vous du jour</h3>
          <span className="son-chip son-chip-gray ml-1">{rows.length}</span>
        </div>
        <button onClick={() => navigate('/planning')}
          className="inline-flex items-center gap-1 text-[12.5px] font-bold" style={{ color: 'var(--teal)' }}>
          Voir l'agenda <ArrowRight className="h-3.5 w-3.5" />
        </button>
      </div>

      {isLoading ? (
        <div className="py-6 text-center text-gray-400 text-sm">Chargement…</div>
      ) : rows.length === 0 ? (
        <div className="py-8 text-center text-gray-400 text-sm">Aucun rendez-vous aujourd'hui.</div>
      ) : (
        <div className="divide-y" style={{ borderColor: 'var(--border)' }}>
          {rows.slice(0, 8).map((r, i) => (
            <div key={i} className="flex items-center gap-3 py-2.5">
              <div className="text-[13px] font-extrabold text-gray-900 w-12 flex-none tabular-nums">{r[0]}</div>
              <div className="w-[3px] h-8 rounded-full flex-none" style={{ background: 'var(--teal)' }} />
              <div className="flex-1 min-w-0">
                <div className="text-[13.5px] font-semibold text-gray-800 truncate">{r[1]}</div>
              </div>
              <span className={statusChip(String(r[2]))}>{r[2]}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default RdvDuJour;
